import React, { useState, useEffect, Fragment } from 'react';
import {
  Drawer, Modal, Popconfirm, Select, Table,
  notification,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import { connect } from 'react-redux';
import CustomerActions from '@Actions/customerActions';
import './style.scss';
import Helpers from '@Apis/helpers';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import quickUpdateActions from '../../../../actions/quickUpdate/quickUpdateActions';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;

const UpdateTallyCustomer = ({
  isDrawerOpen, getTallyCustomers, tallyCustomers, user, getTallyCustomersLoading, setIsDrawerOpen, data, callback, quickUpdateEntityWise,
}) => {
  const [customerMapping, setCustomerMapping] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedCustomerTally, setSelectedCustomerTally] = useState();
  useEffect(() => {
    getTallyCustomers(user?.tenant_info?.it_id, user.org_id, '', '', data?.[0]?.tally_customers?.[0]?.tally_customer_id);
  }, []);
  useEffect(() => {
    if (data?.length) {
      const initialMappings = data?.map((customer) => ({
        customerId: customer?.customer_info?.customer_id,
        tallyCustomerName: customer?.tally_customers?.[0]?.customer_name || '',
        prev_temp_tally_customer_id: customer?.tally_customers?.[0]?.tally_customer_id,
      }));
      setCustomerMapping(initialMappings);
      setSelectedCustomerTally(data?.[0]?.tally_customers?.[0]?.tally_customer_id || '');
    }
  }, []);
  useEffect(() => {
    if (searchKeyword) {
      const delayDebounceFn = setTimeout(() => {
        getTallyCustomers(user?.tenant_info?.it_id, user?.org_id, searchKeyword);
      }, 1300);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchKeyword]);

  const handleChange = (val, record) => {
    const tempSelectedCustomer = tallyCustomers?.data?.find((item) => item.tally_customer_id === val);
    setCustomerMapping((prevMappings) => {
      const customerIndex = prevMappings.findIndex((product) => product.customerId === record.customer_id);
      const updatedMappings = [...prevMappings];
      updatedMappings[customerIndex] = {
        ...updatedMappings[customerIndex],
        tallyCustomerName: tempSelectedCustomer?.customer_name,
        temp_tally_customer_id: tempSelectedCustomer?.tally_customer_id,
      };
      return updatedMappings;
    });
    setSelectedCustomerTally(tempSelectedCustomer?.tally_customer_id || '');
    setOpen(false);
  };

  const handleSearch = (val) => {
    setSearchKeyword(val);
    setOpen(true);
  };

  const ledgerMappingColumns = () => [
    {
      title: 'Name On Procuzy',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '250px',
      render: (text, record) => (
        <Fragment>
          <H3Text text={`${record?.alias_name}`} />
        </Fragment>
      ),
    },
    {
      title: 'Name On Tally',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '300px',
      render: (text, record) => (
        <Fragment>
          <PRZSelect
            value={selectedCustomerTally}
            showSearch
            onSearch={handleSearch}
            searchValue={searchKeyword}
            open={open}
            filterOption={false}
            allowClear
            onChange={(val) => handleChange(val, record)}
            onDropdownVisibleChange={(isOpen) => setOpen(isOpen)}
            size="small"
            style={{
              width: '300px',
            }}
            disabled={getTallyCustomersLoading}
          >
            {tallyCustomers?.data?.map((item) => (
              <Option key={item.tally_customer_id} value={item.tally_customer_id}>
                {item.customer_name}
              </Option>
            ))}
          </PRZSelect>
        </Fragment>
      ),
    },
    {
      title: '',
      fixed: 'right',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <Popconfirm
          title={(
            <React.Fragment>
              Unlinking the customer will result in the creation of a new ledger/master in Tally.
              <br />
              To avoid duplication, please proceed with caution.
            </React.Fragment>
          )}
          placement="bottomRight"
          onConfirm={() => {
            setLoading(true);
            const payload = {
              customerMapping: [{
                customerId: record?.customer_id,
                tallyCustomerName: '',
                prev_temp_tally_customer_id: record?.tally_customers?.[0]?.tally_customer_id,
              }],
              org_id: user?.tenant_info?.org_id,
              entity_name: 'CUSTOMER',
            };
            quickUpdateEntityWise(payload, () => {
              callback();
              setLoading(false);
            });
          }}

        >
          <div style={{
            marginLeft: 'auto',
            textDecoration: 'underline',
            color: 'rgb(45, 124, 247)',
          }}
          >
            <H3Text
              text="Unlink"
              className="table-subscript"
            />
          </div>
        </Popconfirm>
      ),
    },
  ];
  const handleUpdate = () => {
    setLoading(true);
    const payload = {
      customerMapping,
      org_id: user?.tenant_info?.org_id,
      entity_name: 'CUSTOMER',
    };
    if (!customerMapping?.[0]?.tallyCustomerName) {
      notification.error({
        message: 'Please select customer to update',
        placement: 'top',
        duration: 3,
      });
      setLoading(false);
      return;
    }
    quickUpdateEntityWise(payload, () => {
      callback();
      setLoading(false);
    });
  };
  return (
    <React.Fragment>
      <Table
        showHeader
        size="small"
        columns={ledgerMappingColumns()}
        bordered
        dataSource={data || []}
        pagination={false}
      />
      <div className="custom-drawer__footer flex-display" style={{ width: '100%' }}>
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text="Update"
          onClick={handleUpdate}
          style={{
            borderRadius: '5px',
            padding: '9px 15px',
            width: '100px',
          }}
          isLoading={getTallyCustomersLoading || loading}
          disabled={getTallyCustomersLoading || loading}
        />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CustomerReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  tallyCustomers: CustomerReducers.tallyCustomers,
  getTallyCustomersLoading: CustomerReducers?.getTallyCustomersLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getTallyCustomers: (itId, orgId, searchKeyword, callback, selectedCustomer) => dispatch(CustomerActions.getTallyCustomers(itId, orgId, searchKeyword, callback, selectedCustomer)),
  quickUpdateEntityWise: (payload, Callback, rollback) => dispatch(quickUpdateActions.quickUpdateEntityWise(payload, Callback, rollback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTallyCustomer);
